// extracted by mini-css-extract-plugin
export default {"heading":"style_heading__o5t9z","dataGridComp":"style_dataGridComp__pmg1Z","datagridHead":"style_datagridHead__GV8Ec"};